import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { JobService } from 'src/app/services/job/job.service';
import { Constants } from 'src/app/constants/constants';
import { ClientService } from 'src/app/services/client/client.service';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';
import { DtResponseModel } from 'src/app/models/datatable/dt_response.model';
import { ReportService } from 'src/app/services/report/report.service';
import * as FileSaver from 'file-saver';



@Component({
  selector: 'modal-view-report',
  templateUrl: './modal-view-report.component.html',
  styleUrls: ['./modal-view-report.component.scss'],
})
export class ModalViewReportComponent implements OnInit, AfterViewInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};
  dtRows: any;

  reportName: string;
  reportUid: number;
  columnHeaders: any;


  constructor(private http: HttpClient, public appearanceService: AppearanceService, 
    private userService: UserService, public reportService: ReportService,
   public jobService: JobService, public clientService: ClientService, 
   public modalController: ModalController) {

  }


  ngOnInit() 
  {
    this.createDatatable();
  }


  ngAfterViewInit()
  {
    setTimeout(() => {

      this.dtTrigger.next(null);

      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.on( 'draw.dt', function () {
        if($('.dataTables_empty').length > 0)
        {
          $('.dataTables_empty').remove();
        }
      });
    
      });
      
    }, 300);
  }


  ionViewWillEnter()
  {

  }


  ionViewWillLeave()
  {
    this.dtTrigger.unsubscribe();
  }


  createDatatable()
  {
    const that = this;

    var token = this.userService.getSessionId();

    if (!token)
    {
      setTimeout(() => {

        this.createDatatable();
        
      }, 300);
    }

    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    headers = headers.set('id', this.userService.getSessionId());

    var requestOptions = { headers: headers };

    var theCols = [];

    for (var i = 0; i < this.columnHeaders.length; i++)
    {
      theCols.push({ data: this.columnHeaders[i]} );
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: false,
      columns: theCols,
      lengthMenu: [ 10, 25, 50, 100, 250, 'All' ],
      ajax: (dataTablesParameters: any, callback) => {

        that.appearanceService.showLoading("Please wait...").then(() => {

        that.http
          .post<DtResponseModel>(
            Constants.PROD_URL + 'reports/data/' + this.reportUid,
            dataTablesParameters, requestOptions
            ).subscribe((resp: any) => {

              that.appearanceService.dismissLoading();
              that.dtRows = resp.data;

              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
  
              }, 
              (error: any) => {
          
                that.appearanceService.dismissLoading();
                that.appearanceService.presentToast(error.message, Constants.TOAST_ERROR);

                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
                
              });
            });
      }
    };
  }


  getColumnData(row, columnName)
  {
    return row[columnName];
  }

  async downloadReport()
  {
    var payload = {
      reportUid: this.reportUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      return this.reportService.downloadReport(payload).subscribe((response: any) => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var blob = this.dataURItoBlob(response.File); //new Blob([response.File],  {type: 'application/octet-stream'});
          FileSaver.saveAs(blob, this.reportName + ".xlsx");
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
    
      },
      err => 
      {
        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast("Failed to download.", Constants.TOAST_ERROR);
      });
    });
  }

  private dataURItoBlob(dataURI) 
  {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);
  
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  
    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
  
    // create a view into the buffer
    var ia = new Uint8Array(ab);
  
    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
  
    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], {type: mimeString});
    return blob;  
  }

  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'ViewReportModal');
  }
}